import IndeterminateLoaderAnimation from '@assets/lottie/indeterminate_loader.json';
import React from 'react';
import { AnimationView } from './animation-view';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

interface Props {
  accessibilityLabel: string;
  containerStyle?: StyleProp<ViewStyle>;
  size: number;
}

export const LoadingDots: React.FC<Props> = ({
  accessibilityLabel,
  size = 32,
  containerStyle,
}) => {
  return (
    <View
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ busy: true }}
      style={[styles.container, containerStyle]}
    >
      <AnimationView
        source={IndeterminateLoaderAnimation}
        style={{ height: size, width: size }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
